
        var result = require("!!../../../node_modules/css-loader/index.js!./page-list.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/fw/pages/page-list.component.css
// module id = 2276
// module chunks = 1